import {useState} from 'react'
import { Link } from 'react-router';
import styled from 'styled-components';
import SignModal from '../Sign/SignModal'
import { ProfileMain } from '../Profile/Profile';
import {base} from '../Config/app';
import {Ts, LangSwitcher} from '../Config/switcher';
import {SearchControl} from '../Shared/InputControl';

const HeaderContainer = styled.header`
  display: flex;
  /*justify-content: space-between;*/
  align-items: center;
  padding: 0;
  background-color: #f5f5f5;
  height: 5rem;

`;

const Logo = styled.img`
  height: 5rem;
  border-radius: 50%;
  margin-right: 0.5rem;
`;

const NavLinks = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  vertical-align: middle;
  width: auto;
  visibility: visible;

  @media (orientation: portrait) { 
      visibility: hidden; 
      flex-direction: column;
      gap: 5px;
      max-height: 5rem;
  }

`;


const NavImg = styled.img`
  width: 2rem;
  &:hover {
    transform: scale(1.2);
  }
`;

const Header = ({lang, onLang, onSearch, account}) => {
    //  alert(`Header:account = ${JSON.stringify(account)}`)
    const [showing, Showing] = useState(false)

    const T = (value, key='profile') => Ts(lang, key, value)

    return (      
    <HeaderContainer>
      <Link to="/">
        <Logo src={base.logo} alt={base.domain} title={base.name} />
      </Link>

    <LangSwitcher lang={lang} onLang={onLang} />


{ account.connected &&
<NavLinks>
      <Link className="navbar" to="https://moshaf.akademy.ma/iqrae" target="_blank" rel="noopener noreferrer">{T('iqrae')}</Link>
      <Link className="navbar" to="/page">{T('tadabbor')}</Link>
      <Link className="navbar" to="/sentence">{T('ihfad')}</Link>
      <Link className="navbar" to="/profile">{T('profile')}</Link>
      <Link className="navbar" to="https://moshaf.akademy.ma/nass" target="_blank" rel="noopener noreferrer">{T('nass')}</Link>
</NavLinks> }


    <SearchControl onSearch={onSearch} />

<div className='whatsapp-us'>
    <Link to="https://wa.me/+212660800630" target="_blank" rel="noopener noreferrer">
        <NavImg src="https://akademy.ma/images/wathsapp.png" alt="wathsapp" title="wathsapp" />
    </Link>
</div>

    <ProfileMain lang={lang} account={account} Login={Showing} />


{ showing && 
<SignModal 
    service={account.Service}
    show={showing}
    logo={base.logo}
    onHide={()=>{Showing(false)}}
/> 
}

</HeaderContainer>
                
    )
}

export default Header;